import React from 'react';
import { LoaderProvider } from './components/ui/GlobalLoader';
import ApiStatusBadge from './components/ui/ApiStatusBadge';
import AlerteModeOrdinateur from './components/AlerteModeOrdinateur';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './serviceWorkerRegistration';
import { API_URL } from './config';
import { installerDemo } from './demo/demo';
import { installerProvenance } from './utils/provenance';

const DEMO = installerDemo();
if (!DEMO) installerProvenance();

/* Après une mise en ligne, un téléphone resté ouvert demande d'anciens morceaux de l'appli qui n'existent plus
   (« Loading chunk … failed ») : on recharge la page une fois, sans alerter le gérant. */
const CHUNK = /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module|Importing a module script failed/i;
const rechargerSiAncienneVersion = (message) => {
  if (!CHUNK.test(String(message || ''))) return false;
  try {
    const t = Number(sessionStorage.getItem('evo_reload_chunk') || 0);
    if (Date.now() - t > 60000) { sessionStorage.setItem('evo_reload_chunk', String(Date.now())); window.location.reload(); }
  } catch (e) { window.location.reload(); }
  return true;
};
window.__evoChunk = rechargerSiAncienneVersion;

/* Alerte panne : les erreurs JavaScript des visiteurs sont signalées au gérant (filtrées et limitées côté serveur) */
const signaler = (message) => {
  try {
    if (!message || rechargerSiAncienneVersion(message) || DEMO || /localhost/.test(window.location.host)) return;
    const body = JSON.stringify({ message: String(message).slice(0, 500), page: window.location.pathname });
    if (navigator.sendBeacon) navigator.sendBeacon(`${API_URL}/plus/erreur-client`, new Blob([body], { type: 'text/plain' }));
  } catch (e) { /* ignore */ }
};
window.addEventListener('error', (e) => signaler(e.message || (e.error && e.error.message)));
window.addEventListener('unhandledrejection', (e) => { const r = e.reason; if (r && !r.isAxiosError && !r.response) signaler(r.message || String(r)); });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LoaderProvider>
      <App />
      <ApiStatusBadge />
      <AlerteModeOrdinateur />
    </LoaderProvider>
  </React.StrictMode>
);

// Register PWA Service Worker
registerServiceWorker();
